import { IPartnerSearchQueryParams } from 'clickNgo/models/search'

export const getHighlightedWordsFromFilters = (filters: IPartnerSearchQueryParams): string[] => {
  const { search, partner, contact } = filters
  const partnerWords = [
    partner.taxId,
    partner.partnerId,
    partner.address || partner.legalAddress,
    partner.city || partner.legalCity,
    partner.zipCode,
  ]

  const contactWords = [contact.firstName, contact.lastName, contact.contactId]

  return [search, ...partnerWords, ...contactWords].filter(Boolean)
}
